import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PERMISSION_VIEW_STUDENT_INTELLIGENCE } from './permissionKeys';

function StudentProfileRedirect() {
  const { studentId } = useParams();
  const userRole = useSelector((state) => state.auth.userDetails?.role);
  const permissions = useSelector((state) => state.auth.permissions ?? []);

  const allowed =
    userRole === 'SuperAdmin' ||
    (Array.isArray(permissions) &&
      permissions.includes(PERMISSION_VIEW_STUDENT_INTELLIGENCE));

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return (
    <Navigate
      replace
      to={`/student-intelligence?id=${encodeURIComponent(studentId)}`}
    />
  );
}

export default StudentProfileRedirect;
